export default __webpack_public_path__ + "static/media/41.65d8d226.png";